export default __webpack_public_path__ + "static/media/base-report13.a6efebd2.png";